import React from "react";
import {
  PaginationButton,
  PaginationButtonProps
} from "@silversea-ssc/ui-components-react";
import { useLingui } from "@lingui/react/macro";

type PrevButtonProps = Omit<PaginationButtonProps, "arrow">;

export const PrevButton: React.FC<PrevButtonProps> = (props) => {
  const { t } = useLingui();
  return (
    <PaginationButton
      arrow="left"
      aria-label={t`Previous`}
      role="button"
      {...props}
    />
  );
};
